import React from "react";
import { Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { API_BASE, getToken } from "@/lib/api";

export default function CSVExportButtons() {
  async function download(name) {
    try {
      const token = getToken();
      const res = await fetch(`${API_BASE}/exports/${name}.csv`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${name}.csv`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
      toast.success(`Downloaded ${name}.csv`);
    } catch (err) {
      toast.error(`Failed to export ${name}`);
    }
  }

  return (
    <>
      <Button
        data-testid="export-clients-btn"
        variant="outline"
        onClick={() => download("clients")}
        className="rounded-2xl"
        title="Export clients CSV"
      >
        <Download size={16} className="mr-2" />
        Clients
      </Button>
      <Button
        data-testid="export-sessions-btn"
        variant="outline"
        onClick={() => download("sessions")}
        className="rounded-2xl"
        title="Export sessions CSV"
      >
        <Download size={16} className="mr-2" />
        Sessions
      </Button>
      <Button
        data-testid="export-payments-btn"
        variant="outline"
        onClick={() => download("payments")}
        className="rounded-2xl"
        title="Export payments CSV"
      >
        <Download size={16} className="mr-2" />
        Payments
      </Button>
    </>
  );
}
